import React from "react";
import { Box, BoxProps } from "@mui/material";

export interface CardSurfaceProps extends Omit<BoxProps, "component"> {
  /** Disable the lift-on-hover effect (use for static surfaces). */
  noHover?: boolean;
}

/**
 * Premium card surface for the DCC system.
 *
 * Drop-in replacement for ad-hoc `<Box sx={{ borderRadius: 16, ... }}>`
 * cards on Routes / Planner / Dashboard widgets. Exposes a `noHover`
 * escape hatch for surfaces that shouldn't lift (e.g. dashboards
 * where every panel hovering looks busy).
 *
 * Any extra `sx` you pass merges over the base style.
 */
export default function CardSurface({ children, sx, noHover, ...rest }: CardSurfaceProps) {
  return (
    <Box
      {...rest}
      sx={{
        borderRadius: "16px",
        border: "1px solid #EEF2F7",
        background: "#fff",
        boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
        transition: "all 0.2s",
        ...(noHover
          ? {}
          : {
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 8px 22px rgba(0,0,0,0.08)",
              },
            }),
        ...(sx as object),
      }}
    >
      {children}
    </Box>
  );
}
